var map = {
	"./de/animals.json": [
		14,
		14
	],
	"./de/cars.json": [
		497,
		497
	],
	"./de/city-country.json": [
		41,
		41
	],
	"./de/food.json": [
		153,
		153
	],
	"./de/literature.json": [
		888,
		888
	],
	"./de/people.json": [
		532,
		532
	],
	"./de/sports.json": [
		967,
		967
	],
	"./de/things.json": [
		138,
		138
	],
	"./de/tv.json": [
		527,
		527
	],
	"./de/web.json": [
		493,
		493
	],
	"./en/animals.json": [
		940,
		940
	],
	"./en/cars.json": [
		594,
		594
	],
	"./en/city-country.json": [
		942,
		942
	],
	"./en/food.json": [
		412,
		412
	],
	"./en/literature.json": [
		414,
		414
	],
	"./en/people.json": [
		172,
		172
	],
	"./en/sports.json": [
		986,
		986
	],
	"./en/things.json": [
		156,
		156
	],
	"./en/tv.json": [
		427,
		427
	],
	"./en/web.json": [
		660,
		660
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;